/* global Spiff, SLS_STATE */

export const SPIFF_UNPERSONALISED_LINE_ITEM_PROPERTY_NAME = 'spiffUnpersonalised'

/**
 *
 * @param { {
*  thisId: number
*  inputQueue: number[]
*  outputQueue: object[]
*  onAllComplete: Function
*  onCancel: Function
* } } param0
*/
export async function runSpiff({
  thisId,
  inputQueue = [],
  outputQueue = [],
  onAllComplete = (outputQueue) => { console.log('Set an onAllComplete function to feed into runSpiff, outputQueue', outputQueue) },
  onCancel = (data) => { console.log('Set an onCancel function to feed into runSpiff, data', data) }
}) {
  const { integrationId } = SLS_STATE.spiffConfig
  // console.log('thisId', thisId, 'queue', inputQueue)
  const sleeveProductId = thisId

  // const integrationProduct = new Spiff.IntegrationProduct(`${integrationId}/${sleeveProductId}`)
  const product = new Spiff.Product({ integrationId, productId: sleeveProductId })

  // await activateSpiffClass(integrationProduct, 'integrationProduct')
  await activateSpiffClass(product, 'product')

  const nextInQueue = (data) => {
    // console.log('data onComplete', data, 'inputQueue', inputQueue, 'thisId', thisId)
    outputQueue.push({ spiffTransactionId: data.transactionId, ...data.designMetaData.metadata, thisProductId: thisId })

    const nextId = inputQueue[inputQueue.indexOf(thisId) + 1]
    if (nextId) {
      runSpiff({ thisId: nextId, inputQueue, outputQueue, onAllComplete, onCancel })
      return
    }

    // console.log('complete')
    onAllComplete(outputQueue)
  }

  executeTransaction({ product, onComplete: nextInQueue, onQuit: (data) => { console.warn('err', data); onCancel() } })
}

/**
 * Sets up required information for later consumption when Spiff is ready
 * @returns { void }
 */
function initSpiff () {
  const pageSessionId = window.Spiff.Analytics.createPageSession()
  SLS_STATE.spiffConfig.pageSessionId = pageSessionId
}

/**
 * Accepts a spiff product or spiff integration product and activates it
 * @param { Spiff.Product | Spiff.IntegrationProduct } spiffClass
 * @param { 'product' | 'integrationProduct' } spiffClassString
 */
export const activateSpiffClass = async (spiffClass, spiffClassString) => {
  spiffClass.on('ready', () => {
    // console.log(`${spiffClassString} ready`)
  })
  spiffClass.on('invalid', () => {
    // console.log(`${spiffClassString} invalid`)
  })
  await spiffClass.confirmActive().catch(err => console.error(`Error on confirmActive for ${spiffClassString}`, err))
}

/**
 * @param { Spiff.Product } product
 * @param { string } pageSessionId uuid
 * @returns {
 *   {
 *       presentmentCurrencyCode: 'AUD'
 *       product: Spiff.Product
 *       pageSessionId: string
 *       shouldCreateDesignProduct: boolean
 *     }
 * } Spiff.TransactionOptions
 */
function getTransactionOptions (product, pageSessionId) {
  return {
    presentmentCurrencyCode: 'AUD',
    product,
    pageSessionId,
    shouldCreateDesignProduct: false
  }
}

/**
 *
 * @param {
 *    {
 *      product: SpiffProduct
 *      onComplete?: Function
 *      onQuit?: Function
 *    }
 *  } param0
 * @returns { void }
 */
export function executeTransaction({ product, onComplete, onQuit }) {
  const { pageSessionId } = SLS_STATE.spiffConfig
  const transactionOptions = getTransactionOptions(product, pageSessionId)
  const transaction = new Spiff.Transaction(transactionOptions)

  transaction.on('complete', (data) => {
    // console.log('transaction complete', window.spiffProductId, data)
    if (onComplete) {
      onComplete(data)
    }
  })
  transaction.on('quit', (data) => {
    // console.log('transaction quit', data)
    if (onQuit) {
      onQuit(data)
    }
    // do some error handling
  })
  transaction.execute()
}

window.addEventListener('SpiffApiReady', initSpiff)
